export default function NewsletterForm() {
  return (
    <form className="sm:flex">
      <label htmlFor="email-address" className="sr-only">
        Email address
      </label>
      <input
        id="email-address"
        name="email"
        type="email"
        autoComplete="email"
        required
        className="w-screen max-w-xs rounded-md border-neutral-300 px-5 py-3 placeholder:text-neutral-500 focus:border-rose-500 focus:ring-rose-500 dark:border-neutral-700 dark:bg-neutral-900"
        placeholder="Enter your email"
      />
      <div className="mt-3 rounded-md sm:mt-0 sm:ml-3 sm:shrink-0">
        <button
          type="submit"
          className="flex w-full items-center justify-center rounded-md border border-transparent bg-rose-600 px-5 py-3 text-base font-medium text-white hover:bg-rose-700 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:ring-offset-2 dark:bg-rose-500"
        >
          Notify me
        </button>
      </div>
    </form>
  );
}
